require.ensure(["./acircular"], function(require) {
	require("./acircular");
})


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/acircular2.js
 ** module id = 4
 ** module chunks = 2 6
 **/